import { instance } from "./index";

const getMallInfo = () => {
    return instance.get("/mall/info");
};

const updateMallInfo = (data) => {
    return instance.post("/mall", data);
}

const mallManager = {
    getMallInfo,
    updateMallInfo
};

export default mallManager;
